/* @flow */

import * as Yup from 'yup'

import type { File } from '../../../../types'
import { WEBSHOP_DESIGN_PAGE_MODULE_HEADER } from '../../../shared'
import WebshopHeaderBackdropSettings from './WebshopHeaderBackdropSettings'
import WebshopHeaderBackdrop from './WebshopHeaderBackdrop'

type WidgetSettings = {
  backdrop: File | null,
  height_mode: 'viewport_percentage' | 'keep_image_aspect_ratio' | 'fixed',
  viewport_percentage_height: number,
  fixed_height: number,
  inner_elements_position: 'bottom_left' | 'bottom_center' | 'bottom_right',
}

const widget = {
  component: WebshopHeaderBackdrop,
  settings: WebshopHeaderBackdropSettings,

  available_children: ['link_button', 'text'],
  unavailable_in_modules: [WEBSHOP_DESIGN_PAGE_MODULE_HEADER],
  label: 'Header backdrop',

  default_settings: ({
    backdrop: null,
    height_mode: 'viewport_percentage',
    viewport_percentage_height: 90,
    fixed_height: 500,
    inner_elements_position: 'bottom_left',
  }: WidgetSettings),

  default_style: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  },

  duplicate_reset_fields: ['backdrop'],

  settings_validation: Yup.object().shape({
    data: Yup.object().shape({
      backdrop: Yup.mixed()
        .transform(v => {
          // When it is newly uploaded file, then the value is an array with one element
          if (Array.isArray(v) && v.length > 0) {
            return v
          }
          // When it is already saved file, then the value is just a string cloudinary id
          if (typeof v === 'string' && v.trim() !== '') {
            return v
          }
          // If the value is none of the above, we return undefined, which triggers the required
          // validation check to fail
          return undefined
        })
        .required('Select image or video'),

      height_mode: Yup.string().oneOf([
        'viewport_percentage',
        'keep_image_aspect_ratio',
        'fixed',
      ]),
      viewport_percentage_height: Yup.number().when('height_mode', {
        is: 'viewport_percentage',
        then: Yup.number()
          .typeError('Must be integer')
          .required('Must be integer')
          .integer('Must be integer')
          .min(1, 'Must be 1 or more')
          .max(100, 'Must be 100 or less'),
      }),
      fixed_height: Yup.number().when('height_mode', {
        is: 'fixed',
        then: Yup.number()
          .typeError('Must be integer')
          .required('Must be integer')
          .integer('Must be integer')
          .min(1, 'Must be 1 or more'),
      }),

      inner_elements_position: Yup.string().oneOf([
        'bottom_left',
        'bottom_center',
        'bottom_right',
      ]),
    }),
  }),
}

export default widget
